const childRoutes = (prop) => [
  {
    path: 'information-management',
    name: prop + '.information_management',
    meta: { auth: true },
    component: () => import('../pages/information-management/List.vue')
  },
  {
    path: 'institution-profile-management',
    name: prop + '.institution_profile_management',
    meta: { auth: true },
    component: () => import('../pages/institution-profile-management/List.vue')
  },
  {
    path: 'committee-management',
    name: prop + '.committee_management',
    meta: { auth: true },
    component: () => import('../pages/committee-management/List.vue')
  },
  {
    path: 'evaluation-grading-settings',
    name: prop + '.evaluation_grading_settings',
    meta: { auth: true },
    component: () => import('../pages/evaluation-grading-settings/List.vue')
  },
  {
    path: 'attendance-management',
    name: prop + '.attendance_management',
    meta: { auth: true },
    component: () => import('../pages/attendance-management/List.vue')
  },
  {
    path: 'grading-management',
    name: prop + '.grading_management',
    meta: { auth: true },
    component: () => import('../pages/grading-management/List.vue')
  },
  {
    path: 'evaluation-management',
    name: prop + '.evaluation_management',
    meta: { auth: true },
    component: () => import('../pages/evaluation-management/List.vue')
  },
  {
    path: 'modify-evaluation',
    name: prop + '.modify_evaluation',
    meta: { auth: true },
    component: () => import('../pages/evaluation-management/Modify.vue')
  },
  {
    path: 'institutional-certificate-management',
    name: prop + '.institutional_certificate_management',
    meta: { auth: true },
    component: () => import('../pages/institutional-certificate-management/List.vue')
  },
  {
    path: 'complain-feedback-management',
    name: prop + '.complain_feedback_management',
    meta: { auth: true },
    component: () => import('../pages/complain-feedback-management/List.vue')
  },
  {
    path: 'complain-feedback-report',
    name: prop + '.complain_feedback_report',
    meta: { auth: true },
    component: () => import('../pages/complain-feedback-report/List.vue')
  },
  {
    path: 'e-notification',
    name: prop + '.e_notification',
    meta: { auth: true },
    component: () => import('../pages/e-notification/List.vue')
  },
  {
    path: 'food-management',
    name: prop + '.food_management',
    meta: { auth: true },
    component: () => import('../pages/food-management/List.vue')
  },
  {
    path: 'id-card-management',
    name: prop + '.id_card_management',
    meta: { auth: true },
    component: () => import('../pages/id-card-management/List.vue')
  }
]
const routes = [{
  path: '/child-service/institute-management',
  name: 'child_service.institute-management',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.institute-management')
}]

export default routes
